/** Bound optional device cleanup without letting it block account logout. */
export function signOutDeadline<T>(work: Promise<T>, label: string, ms = 2500): Promise<T> {
  return new Promise((resolve, reject) => {
    const timer = setTimeout(() => reject(new Error(`${label} timed out. Please retry sign out.`)), ms);
    work.then(value => { clearTimeout(timer); resolve(value); }, error => { clearTimeout(timer); reject(error); });
  });
}

type SignOutSteps = {
  disconnectPush: () => Promise<string | null>;
  unlinkDevice: (id: string) => Promise<void>;
  endSession: () => Promise<void>;
  clearAccount: () => void;
  warn: (error: unknown) => void;
};

export async function completeSignOut(steps: SignOutSteps) {
  // Transport opt-out is mandatory before ending the account session.
  const deviceId = await signOutDeadline(Promise.resolve().then(steps.disconnectPush), "Notification disconnect", 5000);
  if (deviceId) {
    // Once transport is off, a failed network delete must not trap the account.
    await signOutDeadline(Promise.resolve().then(() => steps.unlinkDevice(deviceId)), "Device unlink")
      .catch(steps.warn);
  }
  await steps.endSession();
  steps.clearAccount();
}